
jQuery(function($) {

  var LARGEUR_MAX_MOBILE = 1023;
  var l_window = $(window).width();
  var header = $("#masthead");
  var site_navigation = $('#site-navigation');

   $grid = $('.ServiceDetail-Container');
   $grid.masonry({
      itemSelector: '.ServiceDetail-Item',
      percentPosition: true,
      // use outer width of grid-sizer for columnWidth
      columnWidth: '.gridpost-sizer',
      gutter: '.gridpost-gutter-sizer',
      // horizontalOrder: true
      
    });



   var $collection = $('.SectionInView');
    $collection.each(function () {
       new Waypoint.Inview({
          element: this,
          enter: function(direction) {
            $(this.element).addClass('to_anim');
            console.log('LA on entre');
            // console.log(this.element.id + ' enter');
          },
          entered: function(direction) {
            // console.log(this.element.id + ' entered');
             console.log('LA on entre par le bas');
          },//
          exit: function(direction) {
           
          },
          exited: function(direction) {
             $(this.element).removeClass('to_anim');
            // console.log(this.element.id + ' exited');
          }
       });
    });







  // FORM CONTACT LABEL ///

    $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });




/*********************************/
/** DIAPORAMA HOME PAGE  **/
/*********************************/

  $('.SlideHome-js').slick({
        //setting-name: setting-value
      dots: true,
      arrows:false,
      draggable:true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover:false,
      pauseOnFocus:true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      cenerMode:true,
      speed:700,
     // fade: true, // a tester //
      cssEase: 'ease-in-out',
      rows: 1,
       
});



/*********************************/
/** DIAPORAMA EQUIPE **/
/*********************************/

  /* A CHANGER QUAND PLUSIEURS TEMOIGANGES */
  $('.js_slide_testimony').slick({
        //setting-name: setting-value
      dots: false,
      arrows:true,
      draggable:true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover:false,
      pauseOnFocus:true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      cenerMode:true,
      speed:700,
     // fade: true, // a tester //
      cssEase: 'ease-in-out',
      rows: 0,
       responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:true,
          dots: true,
        }
      },
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:false,
          dots: true,
        }
      }
    ]
       
});




});
